interface FundDictionary {
  [key: number]: {
    fundLogo: string;
    bankLogo: string;
  };
}

const fundLogos: { [key: string]: { fundLogo: string; bankLogo: string } } = {};

/**
 * Returns an object with the fund logo and bank logo URLs for a given fund number.
 * If the fund number is not found, returns an object with empty strings.
 * @param {number | null} fundNumber - The fund number to search for.
 * @returns {{fundLogo: string, bankLogo: string}}
 */
export function getFundLogo(fundNumber: number | null): {
  fundLogo: string;
  bankLogo: string;
} {
  if (fundNumber === null) {
    return { fundLogo: '', bankLogo: '' };
  }

  const searchKey = fundNumber === 0 ? '0000' : fundNumber.toString();

  const fund = fundLogos[searchKey];
  if (fund) {
    return fund;
  } else {
    return { fundLogo: '', bankLogo: '' };
  }
}

export function getBankDetailsByFundNumber(fundNumber: number): string {
  const fundNumberStr = fundNumber.toString();

  const fund = data.find((item) => item['מספר קופה באוצר'] === fundNumberStr);

  if (fund) {
    const bank = fund['בנק'] ? fund['בנק'].match(/\d+/)?.[0] || '' : '';
    const branch = fund['סניף'] ? fund['סניף'].match(/\d+/)?.[0] || '' : '';
    const account = fund['מספר חשבון בנק']
      ? fund['מספר חשבון בנק'].toString()
      : '';

    if (!bank || !branch || !account) {
      return 'Invalid fund data';
    }

    return `${bank} . ${branch} . ${account}`;
  } else {
    return 'Fund not found';
  }
}

const data = [
  {
    'מספר קופה באוצר': '14036',
    'אינדקס לוגו': 'Infinity',
    'שם קופה': 'אינפיניטי פנסיה מקיפה',
    'סיווג קופה': 'קרן פנסיה',
    'מספר חשבון בנק': 275546,
    סניף: '574 - שגב',
    בנק: '20 - מזרחי טפחות',
    חברה: '221 - אינפיניטי קופות גמל ופנסיה בעמ',
    'גוף מתפעל': '221 - אינפיניטי פנסיה',
    'קופה פעילה': 'כן',
    'קרן ותיקה': 'לא',
  },
];
